export default function getRatio(ratio) {
    let left = 'col-span-1'
    let right = 'col-span-1'

    switch(ratio) {
        case "I-II-----------I":
            left='col-span-1'
            right='col-span-11'
            break
        case "I--II----------I":
            left='col-span-2'
            right='col-span-10'
            break
        case "I---II---------I":
            left='col-span-3'
            right='col-span-9'
            break
        case "I----II--------I":
            left='col-span-4'
            right='col-span-8'
            break
        case "I-----II-------I":
            left='col-span-5'
            right='col-span-7'
            break
        case "I------II------I":
            left='col-span-6'
            right='col-span-6'
            break
        case "I-------II-----I":
            left='col-span-7'
            right='col-span-5'
            break
        case "I--------II----I":
            left='col-span-8'
            right='col-span-4'
            break
        case "I---------II---I":
            left='col-span-9'
            right='col-span-3'
            break
        case "I----------II--I":
            left='col-span-10'
            right='col-span-2'
            break
        case "I-----------II-I":
            left='col-span-11'
            right='col-span-1'
            break
        default: 
            left='col-span-1'
            right='col-span-1'
    }


    return {left, right}
}